import { render, staticRenderFns } from "./MuokkaaYritys.vue?vue&type=template&id=99457944&"
import script from "./MuokkaaYritys.vue?vue&type=script&lang=js&"
export * from "./MuokkaaYritys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports